// 思路是：判定要克隆的对象是不是引用类型，如果是引用类型，则继续迭代,如果该项是基本类型，则直接复制。
function deepClone(obj) {
  let newObj = Array.isArray(obj) ? [] : {}

  if (obj && typeof obj === "object") {
    for (let key in obj) {
      if (obj.hasOwnProperty(key)) {
        newObj[key] = (obj && typeof obj[key] === 'object') ? deepClone(obj[key]) : obj[key];
      }
    }
  }
  return newObj
}

function chartsData(data) {
  let array = []
  let all = {}
  for (let i = 0; i < data.length; i++) {
    for (let key in data[i]) {
      if (all[key]) {
        all[key].push(data[i][key])
      } else {
        all[key] = [];
        all[key].push(data[i][key])
      }
    }
  }
  for (let key in all) {
    let temp = []
    temp.push(key)
    all[key].forEach((item, index, array) => {
      //执行代码
      temp.push(item)
    })
    array.push(temp)
  }
  return array
}
export default {
  deepClone,
  chartsData
}



// WEBPACK FOOTER //
// ./src/utils/util/ArrayUtil.js